// Saving throw proficiencies that class features grant (2024): Slippery Mind (Rogue 15) adds Wisdom and Charisma, and
// Disciplined Survivor (Monk 14) all six. Plain CommonJS so the server's synchronous saving throw code and the client
// sheet share one rule.
const SLIPPERY_MIND_LEVEL = 15;
const DISCIPLINED_SURVIVOR_LEVEL = 14;
const ALL_SAVES = ['str', 'dex', 'con', 'int', 'wis', 'cha'];

const classLevel = (character, classId) => (Array.isArray(character?.occupation) ? character.occupation : []).reduce((total, entry) => {
  const name = String(entry?.Name ?? entry?.Occupation ?? entry?.name ?? entry?.occupation ?? entry?.class ?? '').trim().toLowerCase();
  const level = Number(entry?.Level ?? entry?.level ?? 0);
  return name === classId && Number.isFinite(level) && level > 0 ? total + level : total;
}, 0);

/** Short ability keys ('wis', 'cha') whose saving throws a class feature makes the character proficient in. */
function featureSaveProficiencies(character) {
  if (classLevel(character, 'monk') >= DISCIPLINED_SURVIVOR_LEVEL) return [...ALL_SAVES];
  return classLevel(character, 'rogue') >= SLIPPERY_MIND_LEVEL ? ['wis', 'cha'] : [];
}

module.exports = { SLIPPERY_MIND_LEVEL, DISCIPLINED_SURVIVOR_LEVEL, featureSaveProficiencies };
